export const SECTORS = [
  { id: 1, name: 'Western Approaches', domain: 'MARITIME', primary: 'RSN', secondary: 'RSAF' },
  { id: 2, name: 'Singapore Strait', domain: 'MARITIME', primary: 'RSN', secondary: 'DIS' },
  { id: 3, name: 'Eastern Anchorage', domain: 'MARITIME', primary: 'RSN', secondary: 'ARMY' },
  { id: 4, name: 'Changi Airspace', domain: 'AIR', primary: 'RSAF', secondary: 'DIS' },
  { id: 5, name: 'Western Airspace', domain: 'AIR', primary: 'RSAF', secondary: 'ARMY' },
  { id: 6, name: 'Northern Land Sector', domain: 'GROUND', primary: 'ARMY', secondary: 'RSAF' },
  { id: 7, name: 'Central Urban', domain: 'GROUND', primary: 'ARMY', secondary: 'DIS' },
  { id: 8, name: 'Jurong Industrial', domain: 'ECONOMIC', primary: 'ARMY', secondary: 'RSN' },
  { id: 9, name: 'Cable Landings', domain: 'DIGITAL', primary: 'DIS', secondary: 'RSN' },
  { id: 10, name: 'National Networks', domain: 'DIGITAL', primary: 'DIS', secondary: 'RSAF' },
];
